<div class="shift-report-table">
    <table
            mat-table
            matSort
            matSortDisableClear
            [dataSource]="dataSource"
            (matSortChange)="sortChangedEvent.emit()"
            (scroll)="onScroll($event)"
            matSortActive="id"
            matSortDirection="desc"
            class="ops-table"
    >
        <ng-container matColumnDef="shiftId">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="shift.id" class="mat-body" [hidden]="isColumnHidden('shiftId')">
                Shift
            </th>
            <td mat-cell *matCellDef="let element" [hidden]="isColumnHidden('shiftId')">
                <a
                        [routerLink]="[InsightsRoute.SHIFT_DETAIL, element.shiftId]"
                        [relativeTo]="activatedRoute"
                        class="ops-link"
                >{{ element.shiftId }}</a
                >
            </td>
        </ng-container>

        <ng-container matColumnDef="phoneNumber">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="mat-body" [hidden]="isColumnHidden('phoneNumber')">
              Phone number
            </th>
            <td mat-cell *matCellDef="let element" [hidden]="isColumnHidden('phoneNumber')">
                {{ element.phoneNumber }}
            </td>
        </ng-container>

        <ng-container matColumnDef="imei">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="mat-body" [hidden]="isColumnHidden('imei')">
              IMEI
            </th>
            <td mat-cell *matCellDef="let element" [hidden]="isColumnHidden('imei')">
                {{ element.imei }}
            </td>
        </ng-container>

        <ng-container matColumnDef="sn">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="mat-body" [hidden]="isColumnHidden('sn')">
              Serial Number
            </th>
            <td mat-cell *matCellDef="let element" [hidden]="isColumnHidden('sn')">
                {{ element.sn }}
            </td>
        </ng-container>

        <ng-container matColumnDef="appVersionCode">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="appVersion" class="mat-body" [hidden]="isColumnHidden('appVersionCode')">
              App Version Code
            </th>
            <td mat-cell *matCellDef="let element" [hidden]="isColumnHidden('appVersionCode')">
                {{ element.appVersionCode }}
            </td>
        </ng-container>

        <ng-container matColumnDef="appVersionName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="mat-body" [hidden]="isColumnHidden('appVersionName')">
              App Version Name
            </th>
            <td mat-cell *matCellDef="let element" [hidden]="isColumnHidden('appVersionName')">
                {{ element.appVersionName }}
            </td>
        </ng-container>

        <ng-container matColumnDef="deviceManufacturer">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="manufacturer" class="mat-body" [hidden]="isColumnHidden('deviceManufacturer')">
              Manufacturer
            </th>
            <td mat-cell *matCellDef="let element" [hidden]="isColumnHidden('deviceManufacturer')">
                {{ element.deviceManufacturer }}
            </td>
        </ng-container>

        <ng-container matColumnDef="deviceModel">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="model" class="mat-body" [hidden]="isColumnHidden('deviceModel')">
              Model
            </th>
            <td mat-cell *matCellDef="let element" [hidden]="isColumnHidden('deviceModel')">
                {{ element.deviceModel }}
            </td>
        </ng-container>

        <ng-container matColumnDef="deviceSdkVersion">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="sdkVersion" class="mat-body" [hidden]="isColumnHidden('deviceSdkVersion')">
              SDK Version
            </th>
            <td mat-cell *matCellDef="let element" [hidden]="isColumnHidden('deviceSdkVersion')">
                {{ element.deviceSdkVersion }}
            </td>
        </ng-container>

        <ng-container matColumnDef="deviceOsVersion">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="osVersion" class="mat-body" [hidden]="isColumnHidden('deviceOsVersion')">
              OS Version</th>
            <td mat-cell *matCellDef="let element" [hidden]="isColumnHidden('deviceOsVersion')">
                {{ element.deviceOsVersion }}
            </td>
        </ng-container>

        <ng-container matColumnDef="deviceOsUid">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="osUid" class="mat-body" [hidden]="isColumnHidden('deviceOsUid')">
              OS UID
            </th>
            <td mat-cell *matCellDef="let element" [hidden]="isColumnHidden('deviceOsUid')">
                {{ element.deviceOsUid }}
            </td>
        </ng-container>

        <!-- not used -->
        <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef>&nbsp;</th>
            <td mat-cell *matCellDef="let element" class="ops-table-action-cell">
                <button mat-icon-button class="ops-table-action-button" aria-label="actions">
                    <mat-icon class="ops-table-action-icon">more_vert</mat-icon>
                </button>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumnsWithAction; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumnsWithAction"></tr>
    </table>
</div>
